import { addToCart, triggerAlert,validateGift } from "./network.js?1791546422"
import  State  from "./state.js?7432987235"
let state = new State();
state.init();

let giftSelectionMode = window.location.search.indexOf("gift-selection") > -1;
if(giftSelectionMode){
  $(".product-grid-item-link").each((i,e)=>{
    $(e).attr("href",$(e).attr("href")+"&gift-selection")
  })
}

// state.giftLevels.map(l => {
//   $(`.reward-${l}`).addClass("gift-product")
// })

const deactivateFilter = () => {
    $("#ProductGridContainer, #SpecialProductGridContainer").addClass("filter-inactive");
    removeEventListener("resize",deactivateFilter);
}

const mobile = window.innerWidth < 768;
if(mobile){
  $("#ProductGridContainer, #SpecialProductGridContainer").addClass("filter-inactive");
  $("#filter").addClass("mobile-rendered"); // dont show filter before its made inactive
} else {
    //create a resize listener that will add "filter-inactive" to #filter when we cross 768px
    addEventListener("resize",deactivateFilter);
}

let colorLookup;

const getColorLookup = async () => {
  let colorsJson = $("#colors-holder").attr("data-url");
  let res = await fetch(colorsJson,{
    method: "GET",
    headers: {
      "Content-Type": "application/json"
    }
  }).then(async (res) => {colorLookup = await res.json(); console.log({colorLookup})})
  return res;
}

let savedSize = state.get("savedSize");
if(savedSize){
  $(".your-size span").text(savedSize);
  $(".your-size").toggleClass("active");
}

$(".size-"+savedSize).addClass("selected");

//START FILTER CODE
let filter = {};
let filtering = false;
let sorting = false;
let userSize = "AA"
const preferredTypeOrder = ['Coat', 'Jacket', 'Jumpsuit', 'Dress',  'Top', 'Pant']
const products = rch_collection_products;

const idealSizeOrder = ["AA","A","BB","B","CC","C","D"]

async function initFilter(){
  let Size = gatherOptions("Size").sort((a,b)=>idealSizeOrder.indexOf(a) < idealSizeOrder.indexOf(b) ? -1 : 1);
  let Color = narrowColors(gatherOptions("Color"));
  let Style = gatherTypes();
  addFilterOptions({Style,Color,Size})
}

function handleFilter(){

}

function clearFilter(){
  filtering = false;
  filter = {};
  $("#filter-clear").removeClass("active");
  $(".filtered").removeClass("filtered");
  $("#filter .selected").removeClass("selected");
  $("#product-grid").removeClass("filtering");
  filterProducts();
  $("#filter-header").text(`Filter (${$('.product-grid-item').length})`)
}

clearFilter();

function gatherOptions(option){
  let allOptions = products.map((p,i)=>{
    let optIndex = p.options.indexOf(option)+1;
    return _.uniq(p.variants.map((v,j)=>v[`option${optIndex}`]))
  })
  return _.uniq(_.flatten(allOptions).filter(o => !!o)).filter(o => o !== "One Size");
}

//get all types included in collection. order according to preferred type order.
function gatherTypes(option){
  return (_.uniq(products.map((p,i)=> p.type)))
  .sort((a,b)=>preferredTypeOrder.indexOf(a) < preferredTypeOrder.indexOf(b) ? 1 : -1);
}

function colorFormat(array){
  //also remove all space
  if(!!!array) 
    return [];
  return array.map(a => a.toLowerCase()).map(a => a.replace(/\s+/g, ''));
}

function narrowColors(colors){
  let found = []
  for (var color in colorLookup) {
    if (colorLookup.hasOwnProperty(color)) {
      if(_.intersection(colorFormat(colorLookup[color].swatchNames),colorFormat(colors)).length){
        found.push(color);
      }
    }
  }
  return found;
}

//DOM functions
function addFilterOptions(optionsObject){
  let filter = $("#filter-sections");
  for (var opt in optionsObject) {
    if (optionsObject.hasOwnProperty(opt)) {
      let section;
      //calculate width of color box is total colors divided by 2 times 3rem
      if(opt === "Color"){
        let colorBoxWidth = (optionsObject[opt].length/2)*3+1;
        section = `
        <div class="filter-section" data-section-name="${opt}">
          <div class="filter-section-label">${opt}</div>
          <div class='color-filter-options' style="width: ${colorBoxWidth}rem">
            ${optionsObject[opt].map(o=>`<div style="background: ${colorLookup[o.toLowerCase()].labelColor}" data-value="${o}" class="filter-option"></div>`).join("")}
          </div>
        </div>
        `;
      } else {
        section = `
        <div class="filter-section" data-section-name="${opt}">
          <div class="filter-section-label">${opt === "Style" ? "Styles" : opt}</div>
          ${optionsObject[opt].map(o=>`<div data-value="${o}" class="filter-option">${o}</div>`).join("")}
        </div>
        `;
      }
      filter.append(section)
    }
  }
}



function toHandle(str,replacer=''){
  return str.replace(/\s+/g, replacer).toLowerCase();
}

$(window).scroll((e)=>{
  if(window.innerWidth < 768){
    $("#filter-wrapper.active").removeClass("active");
  }
  // $("#sortby-modal-container, #sortby").removeClass("active")
})

$(document).click((e)=>{
  // if($(e.target).closest("#sortby, #sortby-modal-container").length){
  //   return false;
  // }
  // //if there's an active sortby container
  // if($("#sortby-modal-container.active").length){
  //   $(e).preventDefault();
  //   $("#sortby-modal-container.active, #sortby.active").removeClass("active");
  // }
});

$(".size-block").click(pickSize)

$("#filter-x").click((e)=>{
  e.stopPropagation();
  $("#filter-wrapper").toggleClass("active")
})

const hideSortBy = () => {
  $("#sortby-modal-container, #sortby").removeClass("active")
  //remove this listener as a scroll listener on window
  $(window).off("scroll",hideSortBy);
}

const blockClickWhileSorting = (e) => {
  if($(e.target).closest("#sortby-modal-container, #sortby").length){

  } else {
    e.preventDefault();
    hideSortBy();
    //remove this function as a click handler
    $(document).off("click",blockClickWhileSorting);
  }
}

$("#sortby").click(()=>{
  //remove no-scroll class
  $("body").removeClass("no-scroll");
  $("#filter-wrapper.active").removeClass("active")
  $("#mini-cart.toggled, header.toggled").removeClass("toggled")
  $("body").addClass("mobile-filter");

  $("#sortby-modal-container, #sortby").toggleClass("active");
  //add a scroll listener with hideSortBy
  $(document).click(blockClickWhileSorting);
  setTimeout(()=>{
    $(window).scroll(hideSortBy);
  },500)
  

})

$("#sortby-x").click(()=>{
  $("#sortby-modal-container, #sortby").toggleClass("active")
  $("body").removeClass("mobile-filter");
  //hide scroll listener hideSortBy
  $(window).off("scroll",hideSortBy);
  $(document).off("click",blockClickWhileSorting);
})

let sortQuery;
$(".sortby-option").click((e)=>{
  let el = $(e.target).closest(".sortby-option");
  let q = el.attr("data-sort-q")
  $(".sortby-option.selected").removeClass("selected");
  el.addClass("selected");
  sortQuery = q;
  let sorted;
  switch (q) {
    case "picks":
      sorted = rch_collection_products.slice()
    break;
    case "newest":
      sorted = rch_collection_products.slice().sort((a,b)=>a.created_at>b.created_at ? 1 : -1)
    break;
    case "price-low":
      sorted = rch_collection_products.slice().sort((a,b)=>a.price>b.price ? 1 : -1)
    break;
    case "price-high":
      sorted = rch_collection_products.slice().sort((a,b)=>a.price<b.price ? 1 : -1)
    break;
    default:

  }
  sorted.forEach((p,i)=> {
    $(`.product-grid-item[data-product-id='${p.id}']`).css("order",i)
  })
  // $("#collection-grid-nav")[0].scrollIntoView()
  let banner = $("#collection-banner");
  let scrollPoint = banner.length ? banner.height()+banner.offset().top : 0;
  window.scrollTo(0,scrollPoint);
})

async function pickSize(e){
  let block = $(e.target).closest(".size-block");
  let size = block.attr("data-size");
  state.set({savedSize: size});
  $(".size-block.selected").removeClass("selected");
  block.addClass("selected");
  $("#picked-size").text("YOUR SIZE: "+size);
  $(".your-size span").text(size);
}

function filterColor(colorChoice){
    let matches = colorLookup[colorChoice.toLowerCase()].swatchNames;
    //loop through every product-grid item and search .color-choices for the first with a classname of the format .color_<swatchName>
    //click that match
    $(".product-grid-item")
    //filter so only unique data-product-id attributes are selected
    .filter((i,el)=>$(".product-grid-item[data-product-id='"+$(el).attr("data-product-id")+"']").index() === i)
    .each((i,el)=>{
        // if(i>3){ return; } 
      let colors = $(el).find(".color-choice").filter((j,el)=>{
        return matches.includes($(el).attr("data-color-name"));
      })
      if(colors.length){
        colors[0].click();
      }
      //for each color after the first, add a duplicate .product-grid-item right after the current one which is just a copy

        for (let i = 1; i < colors.length; i++) {
            let selectedColor = $(colors[i]).attr("data-color-name");
            let clone = $(el).clone();
            clone.addClass("filter-extra-thumb");
            clone.find(".color-choice").removeClass("selected");
            clone.find(".color-choice").eq(i).addClass("selected");
            $(el).after(clone);
            //click the selected color on the clone
            setTimeout(()=>{
                clone.find(`.color-choice.color_${selectedColor}`).click();
            },1);
        }
    })
}

$("#filter").click((e)=>{
  if($(e.target).hasClass("filter-option") && !$(e.target).hasClass("ss__filter-option")){
    $(e.target).toggleClass("selected")
    filterProducts();
    if(mobile){
    //   //filter the products and update the count of matching products
    //   filterProducts();
      let productsInFilter = $(".filtered:not(.extra-color-thumbnail)").length;
    //   let filtersSelected = $(".filter-option.selected").length;
    //   if(filtersSelected > 0){
    //     $("#filter-header").text(`Filter Results (${productsInFilter})`)
        $(".apply-filter").text(`Apply Filter (${productsInFilter})`)
    //   } 
      
    //   return
    }
    let filtersSelected = $(".filter-option.selected").length;
    if(filtersSelected > 0){
      $("#filter-clear").addClass("active");
    } else {
      $("#filter-clear").removeClass("active");
    }
  }
  if($(".color-filter-options .selected").length === 0){
  $(".filter-extra-thumb").remove();
    }
  if($(e.target).closest(`[data-section-name="Color"]`).length && $(e.target).hasClass("selected")){
    let gridItem = $(e.target).closest(".product-grid-item");
    let color = $(e.target).attr("data-value");
    let matches = colorLookup[color.toLowerCase()];
    let firstMatchingColor = matches.swatchNames[0];
      //this will auto select the swatches for each matching product
    // $(`[data-color-name="${toHandle(firstMatchingColor)}"]`).click();

    //use this to make copies that will get deleted when filter changes
    filterColor($(e.target).attr("data-value"));
    if(false)
    colorLookup[$(e.target).attr("data-value").toLowerCase()].swatchNames.forEach(name => {
        //this will auto select the swatches for each matching product
        $(`[data-color-name="${toHandle(name)}"]`).click()
    })
  }
  let productsInFilter = $(".filtered:not(.extra-color-thumbnail)").length;
  let filtersSelected = $(".filter-option.selected").length;
  if(filtersSelected > 0){
    $("#filter-header").text(`Filter Results (${productsInFilter})`)
  } else {
    $("#filter-header").text(`Filter (${$('.product-grid-item').length})`)
  }

  let banner = $("#collection-banner");
  let scrollPoint = banner.length ? banner.height()+banner.offset().top : 0;
  window.scrollTo(0,scrollPoint);
});

$(".mobile.apply-filter").click((e)=>{
  e.preventDefault();
  e.stopPropagation();
  //run the filter, and mark how many products are in the filter
  filterProducts();
  if($(e.target).closest(`[data-section-name="Color"]`).length && $(e.target).hasClass("selected")){
    // let matches = colorLookup[$(e.target).attr("data-value").toLowerCase()];
    // let firstMatchingColor = matches.swatchNames[0];
    // $(`[data-color-name="${toHandle(firstMatchingColor)}"]`).click();
    filterColor($(e.target).attr("data-value"));
    // colorLookup[$(e.target).attr("data-value").toLowerCase()].swatchNames.forEach(name => {
    //   //this will auto select the swatches for each matching product
    //   $(`[data-color-name="${toHandle(name)}"]`).click()
    // })
  }
  let productsInFilter = $(".filtered:not(.extra-color-thumbnail)").length;
  let filtersSelected = $(".filter-option.selected").length;
  if(filtersSelected > 0){
    $("#filter-header").text(`Filter Results (${productsInFilter})`)
  } else {
    $("#filter-header").text(`Filter (${$('.product-grid-item').length})`)
  }
  $("#filter-wrapper").removeClass("active")
  if(filtersSelected > 0){
    $("#filter-clear").addClass("active");
  } else {
    $("#filter-clear").removeClass("active");
  }
  filterProducts();
  $("#ProductGridContainer, #SpecialProductGridContainer").addClass("filter-inactive");
  $("body").removeClass("no-scroll");
  $("body").removeClass("mobile-filter");
  let banner = $("#collection-banner");
  let scrollPoint = banner.length ? banner.height()+banner.offset().top : 0;
  window.scrollTo(0,scrollPoint);
});

$("#filter-header").click((e)=>{
  $("#sortby-modal-container, #sortby").removeClass("active")
  //if filter fixed is there, the filter is always visible
  // if($(".filter-fixed").length && !mobile){
  //   return
  // }
  $("#sortby-modal-container, #sortby").removeClass("active")
  $(e.target).closest("#filter-wrapper").toggleClass("active");
  $("#ProductGridContainer, #SpecialProductGridContainer").toggleClass("filter-inactive");
  $("body").toggleClass("mobile-filter");
});

$(".filter-x").click((e)=>{
  e.stopPropagation();
  $("#filter-wrapper").removeClass("active")
  $("#ProductGridContainer, #SpecialProductGridContainer").addClass("filter-inactive");
  $("body").removeClass("mobile-filter");
  $("body").removeClass("no-scroll");
});

$("#filter-clear").click((e)=>{
  e.preventDefault();
  e.stopPropagation();
  $(`.color-choice:first-child`).click()
  clearFilter();
  $("#filter-header").text(`Filter (${$('.product-grid-item').length})`)
})

function getFilterData(){
  let data = {};
  filtering = false;
  $("#filter .filter-section").map((i,s)=>{
    const selected = $(s).find(".selected").map((j,opt)=>$(opt).attr("data-value")).toArray();
    if(selected.length){
      data[$(s).attr("data-section-name")] = selected;
      filtering = true;
    }

  })
  return data;
}

//all lowercase and no spaces
const lowerCaseNoSpace = (arr) => arr.map(str => str.toLowerCase().replace(/\s+/g, ''));
let loggedP = false;

function filterProducts(){
  filter = getFilterData();
  let allFiltered = [];
  let filtered = products.map((p)=>{
    p.variants = p.variants.filter(v => v.available);
    return p;
  }).slice();
  if(filter["Size"]){
    filtered = filtered.filter(p => {
      let optIndex = p.options.indexOf("Size")+1;
      // if(!loggedP){

      // }
      loggedP = true;
      return p.variants.some(v => v[`option${optIndex}`] && 
        filter["Size"].includes(v[`option${optIndex}`].toUpperCase()) || 
        (v[`option${optIndex}`]?.toUpperCase() === "ONE SIZE")
        );
    })
  }
  if(filter["Style"]){
    filtered = filtered.filter(p => filter["Style"].includes(p.type))
  }

  if(filter["Color"]){
    $("#product-grid").addClass("filtering-color");
    filtered = filtered.filter(p => {
      let optIndex = p.options.indexOf("Color")+1;
      let sizeIndex = p.options.indexOf("Size")+1;
      //check that any color we add corresponds to a size thats in the filter
      let variantColors = _.uniq(p.variants.filter((v) => {
        return filter["Size"] ? filter["Size"].includes(v[`option${sizeIndex}`].toUpperCase()) || 
        (v[`option${optIndex}`].toUpperCase() === "ONE SIZE") : true
      }).map(v => v[`option${optIndex}`])).filter(c => !!c);
      let allowedColors = _.flatten(filter["Color"].map(color => colorLookup[color].swatchNames))

      let matches = _.intersection(lowerCaseNoSpace(variantColors),lowerCaseNoSpace(allowedColors))
      return matches.length > 0;
    }) 
  } else {
    $("#product-grid").removeClass("filtering-color");
  }
  allFiltered = _.uniq(filtered); 
  $(".filtered").removeClass("filtered");
  allFiltered.map(p => {
    const id = p.id;
    $(`[data-product-id='${id}']`).addClass("filtered");
  })
  if(filtering){
    $("#product-grid").addClass("filtering");
  } else {
    $("#product-grid").removeClass("filtering");
  }
}

getColorLookup().then(() => {
  initFilter();
})

//END FILTER CODE

//START THUMB CODE
function initThumbImages(){
    console.log("initting images")
  var thumbs = document.querySelectorAll(".product-grid-item-image:not(.ss__product-grid-item-image)");
  for (var i = 0; i < thumbs.length; i++) {
    var color = thumbs[i].getAttribute("current-color");
    var back = thumbs[i].querySelector(".product-grid-item-image-back");
    var imgUrl = thumbs[i].getAttribute(color+"-b");
    console.log("imgurl",imgUrl)
    back.style.backgroundImage = `url(${imgUrl})`;
  }
}

initThumbImages();


// let is2upNoColorChange = $(".template-name-main2up, .template-name-lookbook2up").length > 0 && window.innerWidth<768;



$(document).on("mouseenter",".color-choice:not(.ss__color-choice)",(e)=> {
  e.preventDefault()
  var choice = $(e.target).attr("data-color-name");
  var displayName = $(e.target).attr("clr-name");
  var thumb = $(e.target).closest(".product-grid-item")
  let product_id = thumb.attr("data-product-id");
  //switch choices
  $(e.target).parent().find(".selected").removeClass("selected");
  $(e.target).addClass("selected")
  //set new images
  var imageElement = thumb.find(".product-grid-item-image");
  var back = imageElement.find(".product-grid-item-image-back");
  var frontUrl = imageElement.attr(`${choice}-f`);
  $(e.target).closest(".product-grid-item-color").find(".color-main-label").text(displayName);
  var img = new Image();
  let width = (Math.ceil(imageElement.width()/100)*100);
//   frontUrl = frontUrl.replace("width=500","width="+width);
  img.src = frontUrl;
  img.onload = function(e){
    imageElement.css({backgroundImage: `url(${frontUrl})`});
  }
  if(window.innerWidth>480){
    var backUrl = imageElement.attr(`${choice}-b`);
    imageElement.attr("current-color",choice);
    // Add width=500 to backUrl
    if (backUrl) {
      if (backUrl.includes("?")) {
        backUrl += "&width=500";
      } else {
        backUrl += "?width=500";
      }
    }
    console.log("backurl",backUrl)
    back.css({backgroundImage: `url(${backUrl})`});
  }
  //set new url
  var currentUrl = thumb.find(".product-grid-item-link").attr("href").split("?")[0];  
  var chosenVariant = (window.search_products ? window.search_products : products).find(p => p.id === parseInt(product_id));//.variants.edges.find(v => toHandle(v.node.selectedOptions[0].value) === choice)
  console.log({chosenVariant,choice})
  if($(".collection-special").length){
    var variantPrice = (chosenVariant.variants.find(v => v.option1.toLowerCase().split(" ").join("") === choice).price/100).toFixed(0);
    thumb.find(".product-grid-item-price").text("$"+variantPrice);
  }
  thumb.attr("data-variant-id",chosenVariant?.id);
  //set price to variant price
  console.log("settings new ",thumb.find(".product-grid-item-link"),`${currentUrl}?color=${displayName}${giftSelectionMode ? "&gift-selection":""}`)
  thumb.find(".product-grid-item-link").attr("href",`${currentUrl}?color=${displayName}${giftSelectionMode ? "&gift-selection":""}`)
})

async function quickAdd(e){
  e.preventDefault();
  e.stopPropagation();
  let thumb = $(e.target).closest(".product-grid-item");
  let index = thumb.index();
  let variant_id = parseInt(thumb.attr("data-variant-id"));
  let color = thumb.find(".product-grid-item-image").attr("current-color");
  let product = products[index];
  let variant = product.variants.find(v => v.id === variant_id);

  if(thumb.hasClass("free-gift")){
    let gift = validateGift(thumb);
    if(gift.id){
      let result = await addToCart(variant,product,gift.collectionId,gift.id);
      roucha_state.giftLevels = roucha_state.giftLevels.filter(l=>l!==gift.id)
      roucha_cart.items = roucha_cart.items.concat(result.items);
    } else {
      triggerAlert('Unable To Add Free Gift To Your Cart');
    }
  }
   else {
    let result = await addToCart(variant,product);
  }
}
$(".quick-add").click(quickAdd);
//END THUMB CODE

const ensureColorLabelsShowing = () => {
  $(".left-overflow").removeClass("left-overflow");
  $(".right-overflow").removeClass("right-overflow");
  let innerW = window.innerWidth;
  let labels = $(".color-label");
  let cutoffLabels = labels.each((i,l) => {
    let {x,width} = l.getBoundingClientRect();
    if(x < 0){
      l.classList.add("left-overflow");
    } else if ((x+width)>innerW){
      l.classList.add("right-overflow");
    }
  });

}

addEventListener("resize",ensureColorLabelsShowing);
ensureColorLabelsShowing();

